import React from 'react';
import { Paper, PaperProps } from '@mui/material';

export interface SectionPaperProps
  extends Omit<PaperProps, 'variant'> {
  children: React.ReactNode;
}

/**
 * A reusable Paper component for wrapping sections in the admin panel.
 * Features a dashed border, subtle background, rounded corners, and sizes to its content.
 */
export const SectionPaper: React.FC<SectionPaperProps> = ({
  children,
  sx,
  ...props
}) => (
  <Paper
    variant="outlined"
      sx={{
        padding: '1rem',
        borderStyle: 'dashed',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        backgroundColor: 'rgba(255, 255, 255, 0.02)',
        borderRadius: '8px',
        display: 'block',
        width: '100%',
        ...sx,
      }}
    {...props}
  >
    {children}
  </Paper>
);
